export enum ColorMode {
  DARK = 'dark',
  LIGHT = 'light',
  OCEANIC = 'oceanic',
}

const ColorModeValueStrings = Object.values(ColorMode).map(String)

export const isColorMode = (color: string): color is ColorMode => {
  return ColorModeValueStrings.includes(color)
}

// Inclusive gender taxonomy for better representation
export type GenderId =
  | 'man'
  | 'woman'
  | 'nonbinary'
  | 'agender'
  | 'other' // legacy / custom bucket
  | 'prefer_not_to_say'
  | 'unknown'

export type PreferredGender =
  | 'any'
  | GenderId
  | { include: GenderId[]; exclude?: GenderId[] }

export interface UserSettings {
  colorMode: ColorMode
  userId: string
  customUsername: string
  playSoundOnNewMessage: boolean
  showNotificationOnNewMessage: boolean
  showActiveTypingStatus: boolean
  isEnhancedConnectivityEnabled: boolean
  publicKey: CryptoKeyPair['publicKey']
  privateKey: CryptoKeyPair['privateKey']
  selectedSound: string
  interests: string[]
  region?: string
  language?: string
  gender?: GenderId
  preferredGender?: PreferredGender
}
